import { yupResolver } from '@hookform/resolvers/yup';
import { AxiosError } from 'axios';
import { ChangeEvent, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import StickButtonsBloc from '../../blocs/common/StickButtonsBloc';
import { APP_URLS, ERROR_MESSAGES, MAX_SMALL_MOBILE_WIDTH } from '../../const/AppConst';
import useAppState from '../../context/AppContext';
import { IApiErrors, IBeneficiaryAdditionReq, IExtractedSecurityInfo, IUploadedDocument } from '../../context/model';
import MgpMessage from '../../elements/MgpMessage/MgpMessage';
import LoaderModal from '../../modals/common/LoaderModal';
import UploadFilePreviewModal from '../../modals/common/UploadFilePreviewModal';
import { deleteDocument, downloadUploadedDocument, uploadSocialSecurity } from "../../services/CustomerApiService";
import QrCodeModal from '../../modals/common/QrCodeModal';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { isPropositionInLock } from '../../utils/dataUtils';
import { getCompressFile, getFilename, isAcceptedFileSize, isMobile, isValidBirthdateOfBeneficiary, isValidFileSize, isValidFileType } from '../../utils/utils';
import ListOfFileUploaded from '../common/ListOfFileUploaded';
import MgpInputFileUpload from '../../elements/MgpInputFileUpload/MgpInputFileUpload';
import UploadFromPhoneButton from '../common/UploadFromPhoneButton';

type InfoBeneficiaryStep1FormData = {
  attachmentOrganization: string;
  teletranmissionRefuse: boolean;
  alsaceMoselleRegime: boolean;
}

export default function InfoBeneficiaryStep1FormComponent() {

  const {
    state: { proposition, updatedProposition, jwtToken, socialSecurityDocuments, additionalData, showModal },
    dispatch,
  } = useAppState();

  const validationSchema = Yup.object().shape({
   
  });
  
  const [errorMsg, setErrorMsg] = useState<string | null>();
  
  const [errorFileTypeMsg, setErrorFileTypeMsg] = useState<boolean | null>();
  const [errorFileSizeMsg, setErrorFileSizeMsg] = useState<boolean | null>();
  const [loading, setLoading] = useState<boolean>(false);
  const [file, setFile] = useState<File | null>(null);
  const [openPreviewFile, setOpenPreviewFile] = useState<boolean>(false);
  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const [hasModify, setHasModify] = useState<boolean>(false);
  const [showUploadButtonOnModal, setShowUploadButtonOnModal] = useState<boolean>(false);
  const [showUploadField, setShowUploadField] = useState<boolean>(false);

  const {width} = useWindowDimensions();
  const isDesktop = width > MAX_SMALL_MOBILE_WIDTH;

  useEffect(() => {
    if (socialSecurityDocuments && socialSecurityDocuments.filter(doc => doc.name !== "Attestation de droits").length > 0) {
      setShowUploadField(true);
    }
  }, [socialSecurityDocuments] )

  const showQrCodeNotPrincipal= () => {
    setIsShowModal(true);
  }

  const showQrCodeModal = () => {
    setIsShowModal(true);
  }
  const closeModal = () => {
    setIsShowModal(false)
  }

  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    try {
      const uploadedfile = event.target.files ? event.target.files[0] : null;
  
      if (uploadedfile) {
        if(!isValidFileType(uploadedfile)) {
          setErrorFileTypeMsg(true)
        } else if(!isValidFileSize(uploadedfile)) {
          setErrorFileSizeMsg(true)
        } else if (!isAcceptedFileSize(uploadedfile)) {
          try {
            const token = jwtToken!.accessToken;
            const newFile = await getCompressFile(token, uploadedfile);
            setFile(newFile);
            setOpenPreviewFile(true);
            setShowUploadButtonOnModal(true);
            dispatch({type: 'SHOW_MODAL', showModal: true});
          }  catch(e) {
            setErrorMsg("Suite à un incident technique, nous ne pouvons pas uploader votre fichier. Veuillez sélectionner à nouveau.");
          } 
        } else {
          setFile(uploadedfile);
          setOpenPreviewFile(true);
          setShowUploadButtonOnModal(true);
          dispatch({type: 'SHOW_MODAL', showModal: true});
        }
      }
    } catch (error) {
      const err = error as AxiosError;
      console.log(err);
      if(err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        setErrorMsg("Erreur: " + errorData.message);
      } else {
        setErrorMsg("Une erreur technique est survenue ");
      }
    }
  };


  
  const navigate = useNavigate();

  const {
    register,
    handleSubmit, 
    formState: { errors, isSubmitting },
  } = useForm<InfoBeneficiaryStep1FormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
      attachmentOrganization: updatedProposition?.attachmentOrganization,
      teletranmissionRefuse: updatedProposition?.teletranmissionRefuse? true: false,
      alsaceMoselleRegime: updatedProposition?.alsaceMoselleRegime ? true : false
    },
    resolver: yupResolver(validationSchema),
  });

  const hasAddedBeneficiary = proposition?.configuration?.canBeAddedBeneficiaries && (additionalData?.hasPartner || additionalData?.hasChild);
 
  const onNextAction = (data: InfoBeneficiaryStep1FormData) => {
    let tempUpdatedPropo = updatedProposition;
    let beneficiaries = [] as IBeneficiaryAdditionReq[];
    if (hasAddedBeneficiary) {
      beneficiaries =  updatedProposition?.beneficiaries ? updatedProposition?.beneficiaries : [];
      if (hasModify) {
        socialSecurityDocuments?.filter(el => el.extractedData).map(doc => doc.extractedData?.beneficiaries?.map((extractedInfo) => {
          if (proposition?.contact?.nir !== extractedInfo?.nir && beneficiaries.findIndex(el => el?.contact?.nir === extractedInfo?.nir) === -1 && isValidBirthdateOfBeneficiary(extractedInfo?.birthDate, proposition?.effectiveDate)) {
            const beneficiaryProps = {
              contact: {
                firstName: extractedInfo.firstName,
                lastName: extractedInfo.lastName,
                birthDate: extractedInfo.birthDate,
                civilityCode: extractedInfo.civilityCode,
                regimeCode: extractedInfo.regimeCode,
                attachmentOrganization: extractedInfo.socialSecurityOrg,
                nir: extractedInfo.nir,
                nirKey: extractedInfo.nirKey
              },
              isConfirmed: false
            } as IBeneficiaryAdditionReq;
            
            beneficiaries.push(beneficiaryProps)
          }
        }));
      }   
    };

    if(tempUpdatedPropo) {
      tempUpdatedPropo.attachmentOrganization = data.attachmentOrganization;
      tempUpdatedPropo.teletranmissionRefuse = data.teletranmissionRefuse;
      tempUpdatedPropo.beneficiaries = beneficiaries;
      tempUpdatedPropo.alsaceMoselleRegime = data.alsaceMoselleRegime;
    };

    if (additionalData?.hasPartner || additionalData?.hasChild) {
      dispatch({type: 'NEXT_INFO_STEP', path: APP_URLS.infoBeneficiaryStep2Page, updatedProposition: tempUpdatedPropo});
      navigate({
        pathname: APP_URLS.infoBeneficiaryStep2Page,
        search: `?id=${proposition!.propositionId}`,
      });
    } else {
      dispatch({type: 'NEXT_INFO_STEP', path: APP_URLS.familyDocumentsPage, updatedProposition: tempUpdatedPropo});
      navigate({
        pathname: APP_URLS.familyDocumentsPage,
        search: `?id=${proposition!.propositionId}`,
      });
    }
  }

  const onUploadAction = async () => {
    setErrorMsg(null);
    setErrorFileTypeMsg(false);
    setErrorFileSizeMsg(false);
    setLoading(true);
    try {
      const token = jwtToken!.accessToken;
      const res = await uploadSocialSecurity(token, proposition!.propositionId, file as File, true, false);
      setLoading(false);
      if (res.data) {
        const secuDocument = res.data;
        onUpdatedFormValue(secuDocument);
        setHasModify(true);
        setShowUploadButtonOnModal(true);
      } else {
        setErrorMsg(ERROR_MESSAGES.lowQualityDoc);
      }
   
    } catch (error) {
      setLoading(false);
      const err = error as AxiosError;
      console.log(err);
      if(err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        setErrorMsg("Erreur: " + errorData.message);
      } else {
        setErrorMsg("Une erreur technique est survenue.");
      }
    }
  }

  const onEventMessage = (message: any, type: string) => {
    if(type === 'upload') {
      const socialSecurityDocuments = message as IUploadedDocument<IExtractedSecurityInfo>;
      onUpdatedFormValue(socialSecurityDocuments);
      setHasModify(true);
      setIsShowModal(false);
      setShowUploadButtonOnModal(false);
    }
  }

  const onUpdatedFormValue = (secuDocument: IUploadedDocument<IExtractedSecurityInfo>) => {
    dispatch({type: 'EXTRACT_SECU_ATTEST', socialSecurityDocuments: [...socialSecurityDocuments, secuDocument]});
  }

  const onPreviousAction = () => {
      dispatch({type: 'BACK_INFO_STEP', path: APP_URLS.infoBeneficiaryStep0Page});
      navigate({
        pathname: APP_URLS.infoBeneficiaryStep0Page,
        search: `?id=${proposition!.propositionId}`,
      });
  }

  const onDownLoadDocument = async (documentId: string) => {
    try {
      const token = jwtToken!.accessToken;
      const res = await downloadUploadedDocument(token, proposition!.propositionId, documentId);
      const content = new Blob([res.data], {type: res.headers['content-type']});
      const filename= getFilename(res.headers);
      const file = new File([content], filename);
      setFile(file);
      setOpenPreviewFile(true);
      setShowUploadButtonOnModal(false);
      dispatch({type: 'SHOW_MODAL', showModal: true});

    } catch (error) {
      setLoading(false);

      const err = error as AxiosError;
      console.log(err);
      if(err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        setErrorMsg("Erreur: " + errorData.message);
      } else if (err.response && err.response.status === 404) {
        setErrorMsg(ERROR_MESSAGES.documentNotFound);
      } else {
        setErrorMsg("Une erreur technique est survenue ");
      }
    }
  }

  const onDeleteDocLocal = (documentId: string) => {
      const newDocumentArray = [...socialSecurityDocuments];
      const index= newDocumentArray.findIndex(el => el.id === documentId);
      newDocumentArray.splice(index, 1);
      dispatch({type: 'EXTRACT_SECU_ATTEST', socialSecurityDocuments: newDocumentArray});
      setHasModify(true);
  }


  const onDeleteDocument = async (documentId: string) => {
    try {
      const token = jwtToken!.accessToken;
      await deleteDocument(token, proposition!.propositionId, documentId);
 
      onDeleteDocLocal(documentId);
      setErrorMsg(null);
      
    } catch (error) {
      const err = error as AxiosError;
      console.log(err);
      if(err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        setErrorMsg("Erreur: " + errorData.message);
      } else if (err.response && err.response.status === 404) {
        onDeleteDocLocal(documentId);
        setErrorMsg(null);
      } else {
        setErrorMsg("Une erreur technique est survenue ");
      }
    }
   
  }

  const docs = socialSecurityDocuments.filter(doc => doc.name !== "Attestation de droits");

  const displayBeneficiary = () => {
    let message = '';
    let status = 'info';
 
    if(docs?.find(el => el.extractedData?.isValid === false)) {
      message = 'Nous n\'avons pas réussi à identifier le document. Nous vous invitons à nous le transmettre sous un autre format ou à saisir vos données.';
      status = 'alert';
    } else if(docs?.find(el => el.extractedData?.isValidDuration === false)) {
      message = 'Votre attestation de droits à l’assurance maladie n’est plus valable. Vous devez télécharger une attestation de droits à jour.';
      status = 'alert';
    }

    return (
      <div>
        {message &&
          <p className={'text bg-menthe blanc m-y-md p-sm mw-100 ' + (status === 'alert' ? 'bg-orange' : 'bg-menthe')}>
            {message}
          </p>
        }
      </div>
    )
  }

  return (       
      <form style={{width: '100%'}}>   
         <div className='form-row page-content'>
          <div className='col-flex-4 bg-blanc shadow-noir p-lg m-y-xs'>
            <h2 className='card-title bleu'>Attestation de droits à l'Assurance maladie pour les ayants droit</h2>
            <p className='text mt-md' style={{textAlign: 'justify'}}>
              Si vous souhaitez ajouter des ayants droit non mentionnés dans votre attestation de droits à l'Assurance maladie (4 maximum), vous devez maintenant télécharger leur attestation de droits à l'Assurance 
              maladie.
            </p>
            <p className='text mt-xs' style={{textAlign: 'justify'}}>
              Après votre affiliation et à tout moment, vous aurez la possibilité de rajouter vos ayants droit depuis
              votre espace adhérent.
            </p>
            <p className='text mt-xs'>Veuillez passer cette étape si ce n'est pas votre cas.</p>

            {displayBeneficiary()}
            
            {
              docs.length === 0 && !showUploadField && 
              <button className='cta-bleu p-y-lg m-y-lg' onClick={() => setShowUploadField(true)}>Ajouter un document</button>
            }
            
            <div className='form-row'>
              <div className='form-group mw-100'>
              {
                hasAddedBeneficiary && docs.length > 0 && docs.map (doc =>
                  <div className='p-y-xs' key={doc.id}> 
                    <ListOfFileUploaded 
                      fileName= {doc.name}
                      onDownloadDocument={() => onDownLoadDocument(doc.id)}
                      onDeleteDocument={() => onDeleteDocument(doc.id) }
                    />
                  </div>
              ) 
              }
              </div>
            </div>
            { 
              showUploadField && docs.length < 4 && !showModal &&
              <div className="form-row">
                <div className='form-group mw-50'>
                  <MgpInputFileUpload
                  id="attachId2"
                  onChange={(e) => handleFileChange(e)}
                  register={register} 
                  errors={errors}
                  required={false}
                  onClick={(e)=> e.currentTarget.value = ''}
                  />
                </div>
                {
                  isDesktop && <div className="form-group mw-5 ta-center pt-xl"><p className='fz-lg'>ou</p></div>
                }
                {isDesktop && 
                <div className='form-group mw-50'>
                  <UploadFromPhoneButton onClick={() => showQrCodeNotPrincipal()}/> 
                </div>}
              </div>
            }

          <div className='form-row'>
            <div className='form-group mw-100'>
              {errorFileTypeMsg && <p className='text blanc p-sm bg-fushia'>{ERROR_MESSAGES.fileTypeMsg}</p> }
              {errorFileSizeMsg && <p className='text blanc p-sm bg-fushia'>{ERROR_MESSAGES.fileSizeMsg}</p> }
            </div>
          </div>   
           
           
          </div>
 
          <div className='col-flex-4 bg-blanc shadow-noir p-lg m-y-xs'>
            <h2 className='card-title bleu'>Où trouver l'attestation de droits de votre enfant&nbsp;?</h2>

            <div className='quick-bloc va-center jc-center mt-md icon-img'>
              <div className='col-flex-1 ta-center bg-blanc'>
                <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/Picto_Tel.svg"} width={isMobile() ? "100%" : "80%"} height="100%" style={{boxShadow: "none"}} alt=''/>
              </div>
              <div className='col-flex-8'>
                <p className='text'>Connectez-vous à votre compte ameli via l'application ou le site ameli.fr</p>
              </div>
            </div>
                
            <div className="quick-bloc">
              <div className='col-flex-1 va-center jc-center quick-bloc'>
                <div className="vertical-line-top" ></div>
              </div>
              <div className='col-flex-8 bg-blanc'></div>
            </div>
            
            <div className='quick-bloc va-center jc-center mt-lg icon-img'>
                  <div className='col-flex-1 ta-center bg-blanc'>
                    <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/Picto_Doc.svg"} width={isMobile() ? "100%" : "80%"} height="100%" style={{boxShadow: "none"}} alt=''/>
                  </div>
                  <div className='col-flex-8'>
                    <p className='text'>
                      Téléchargez une attestation de droits en sélectionnant votre enfant dans le menu déroulant&nbsp;:
                      <br/>
                      - rubrique « Mes démarches » sur le site internet&nbsp;;
                      <br/>
                      - rubrique « Mes documents » dans l’appli. 
                    </p>
                  </div>
            </div>

            <div className="quick-bloc">
              <div className='col-flex-1 va-center jc-center quick-bloc'>
                <div className="vertical-line-bottom" ></div>
              </div>
              <div className='col-flex-8 bg-blanc'></div>
            </div>

            <div className='quick-bloc va-center jc-center mt-lg icon-img'>
                  <div className='col-flex-1 ta-center bg-blanc'>
                    <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/Picto_case.svg"} width={isMobile() ? "100%" : "80%"} height="100%" style={{boxShadow: "none"}} alt=''/>
                  </div>
                  <div className='col-flex-8'>
                    <p className='text'>Vous retrouvez le numéro de sécurité sociale de votre enfant dans la case «&nbsp;n° de sécurité sociale du bénéficiaire&nbsp;».</p>
                  </div>
                </div>

          </div>
          
        </div>            

        {openPreviewFile&&file&&<UploadFilePreviewModal file={file} onUploadAction={onUploadAction} isOpen={openPreviewFile} onCloseModal={() => {setOpenPreviewFile(false);  dispatch({type: 'SHOW_MODAL', showModal: false});}} showButton={showUploadButtonOnModal}/>} 

        {
          !showModal && <StickButtonsBloc disabledPreviousButton={proposition && isPropositionInLock(proposition) ? true : false} showNextButton={true} showPreviousButton={true} previousAction={onPreviousAction} nextAction={handleSubmit(onNextAction)}/>
        }

        {isShowModal && <QrCodeModal isOpen={isShowModal} onShowQrCode={showQrCodeModal} onCloseModal={closeModal} docCode={"SOCIAL_SECURITY_CERTIFICATE_BENEFICIARY"} onEventMessage={onEventMessage} /> }
        {(isSubmitting || loading) && <LoaderModal hasMessage={false}/>}
        <div>
          {errorMsg && <MgpMessage type="danger" message={errorMsg} hasCloseBtn={true}/>}
        </div>
      </form>
  )
}
